export default __webpack_public_path__ + "images/FI.b42e7e3.png";